export const DEFAULT_TAKE_UNTIL_TIME = 5000;
export const DEFAULT_DEBOUNCE_TIME = 300;
